import React from 'react';
const bonuses = [{
  num: '01',
  title: 'Pack Publicación que Vende',
  desc: '30 publicaciones listas para copiar y pegar en Marketplace. 15 títulos gancho. Respuestas automáticas para WhatsApp.',
  value: '8.990',
  color: 'bg-brand-steel'
}, {
  num: '02',
  title: 'Kit Fotos Pro con Celular',
  desc: 'Setup barato con recursos de tu casa, 20 encuadres que detienen el scroll y edición en 60 segundos con apps gratuitas.',
  value: '7.990',
  color: 'bg-brand-rust'
}, {
  num: '03',
  title: 'Checklist Taller Seguro y Prolijo',
  desc: 'Checklists imprimibles para cada etapa, las 12 fallas más comunes y planner semanal para el que tiene trabajo.',
  value: '5.990',
  color: 'bg-brand-amber'
}];
export function BonusSection() {
  return <section className="py-24 px-4 bg-brand-dark text-white" data-id="element-19">
      <div className="max-w-6xl mx-auto" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <h2 className="text-4xl md:text-6xl font-black text-brand-amber mb-6 uppercase tracking-tight" data-id="element-22">
            Más los 3 Bonos de Regalo
          </h2>
          <p className="text-2xl font-bold text-gray-300 mb-4" data-id="element-23">
            Incluidos en tu compra — sin costo extra
          </p>
          <div className="inline-block bg-brand-green text-white text-2xl font-black px-8 py-3 rounded-full animate-pulse-fast shadow-[0_0_20px_rgba(22,163,74,0.5)]" data-id="element-24">
            🎁 GRATIS por el día de hoy
          </div>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-25">
          {bonuses.map((b, i) => <div key={i} className="bg-[#292524] rounded-2xl overflow-hidden border border-gray-700 shadow-2xl flex flex-col h-full" data-id="element-26">
              <div className={`aspect-square ${b.color} p-8 flex flex-col items-center justify-center text-center relative`} data-id="element-27">
                <div className="absolute top-4 left-4 bg-white text-black font-black text-2xl px-4 py-1 rounded-lg" data-id="element-28">
                  {b.num}
                </div>
                <h3 className="text-3xl md:text-4xl font-black text-white leading-tight drop-shadow-md" data-id="element-29">
                  BONO {parseInt(b.num)}
                </h3>
                <p className="text-xl font-bold mt-4 text-white/90 drop-shadow-md px-4" data-id="element-30">
                  {b.title}
                </p>
              </div>

              <div className="p-8 flex flex-col flex-grow" data-id="element-31">
                <div className="flex items-center gap-2 mb-4" data-id="element-32">
                  <span className="text-2xl" data-id="element-33">🎁</span>
                  <h4 className="text-xl font-bold text-brand-amber" data-id="element-34">
                    BONO {parseInt(b.num)}
                  </h4>
                </div>
                <h5 className="text-2xl font-bold mb-4" data-id="element-35">{b.title}</h5>
                <p className="text-gray-300 text-lg mb-8 flex-grow" data-id="element-36">{b.desc}</p>

                <div className="mt-auto pt-6 border-t border-gray-700 flex justify-between items-center" data-id="element-37">
                  <div className="text-gray-400 font-medium" data-id="element-38">
                    Valor: <span className="line-through" data-id="element-39">${b.value}</span>
                  </div>
                  <div className="text-brand-green font-black text-2xl" data-id="element-40">
                    GRATIS
                  </div>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-[#292524] border-2 border-brand-amber rounded-2xl p-8 text-center max-w-3xl mx-auto" data-id="element-41">
          <p className="text-2xl text-gray-300 mb-2" data-id="element-42">
            Valor total de los 3 Bonos:{' '}
            <span className="line-through" data-id="element-43">$22.970 ARS</span>
          </p>
          <p className="text-3xl md:text-4xl font-black text-brand-green" data-id="element-44">
            🎁 GRATIS — Solo con tu compra. Siempre.
          </p>
        </div>
      </div>
    </section>;
}